import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';

/**
 * Wrapper oko PrimeNG MessageService koji za error poruke postavlja sticky: true,
 * tako da se error poruke ne miču automatski nego ih korisnik mora ručno zatvoriti.
 * Ostale poruke (success, info, warn) zadržavaju standardno ponašanje (nestaju nakon timeouta).
 */
@Injectable()
export class EarhivMessageService extends MessageService {
  override add(message: Message) {
    if (message.severity === 'error') {
      super.add({ ...message, sticky: true, closable: true });
    } else {
      super.add(message);
    }
  }

  override addAll(messages: Message[]) {
    const modified = messages.map((m) =>
      m.severity === 'error' ? { ...m, sticky: true, closable: true } : m
    );
    super.addAll(modified);
  }
}
